var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".how-bucks-back-works-steps-modal .text-center[data-v-10]{padding-top:30px}.how-bucks-back-works-steps-modal .modal-body[data-v-10]{width:740px}.how-bucks-back-works-steps-modal h2[data-v-10]{margin-bottom:55px}.how-bucks-back-works-steps-modal .step[data-v-10]{text-align:center}.how-bucks-back-works-steps-modal .step h3[data-v-10]{font-size:1.142857em;font-weight:600;margin-bottom:10px}")
;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  data: function() {
    return {
      steps: [1, 2, 3, 4]
    };
  },
  props: {
    loggedIn: Boolean,
    hasCCookie: Boolean
  },
  components: {
    BucksBackLoginButton: require('./bucks-back-login-button.vue')
  },
  mounted: function() {
    var hasOpenModal, landOnHomeFromEmail;
    landOnHomeFromEmail = $('body').hasClass('coupons-home') && /[?&]utm_medium=email($|&)/.test(window.location.search);
    hasOpenModal = require('../../../shared/frontend/helpers/helpers').hasOpenModal();
    if (landOnHomeFromEmail && !hasOpenModal) {
      Groupon.Utils.lazyLoadImages();
      return GIG.Modal.open({
        id: 'how-bucks-back-works-steps-modal'
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"modal how-bucks-back-works-steps-modal",attrs:{"id":"how-bucks-back-works-steps-modal"}},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close-modal icon-x"}),_v(" "),_c('h2',{staticClass:"modal-title"},[_v(_s(t('js.modules.rewards.common.how_bucks_back_works')))]),_v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"steps row"},_l((steps),function(step){return _c('div',{staticClass:"step columns three"},[_c('img',{staticClass:"lazy-load",attrs:{"alt":"","data-original":'/coupons/images/bucks-back/bucks-back-illustrations-' + step + '.png',"data-original-2x":'/coupons/images/bucks-back/bucks-back-illustrations-' + step + '@2x.png'}}),_v(" "),_c('h3',[_v(_s(step)+". "+_s(t('js.modules.rewards.hiw_steps_modal.step' + step + '.heading')))]),_v(" "),_c('p',[_v(_s(t('js.modules.rewards.hiw_steps_modal.step' + step + '.wording')))])])})),_v(" "),_c('div',{staticClass:"text-center"},[_c('bucks-back-login-button',{attrs:{"logged-in":loggedIn,"has-c-cookie":hasCCookie}})],1),_v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"more",attrs:{"href":t('js.modules.rewards.common.faq_link_url'),"target":"_blank"}},[_c('span',[_v(_s(t('js.modules.rewards.common.more_details')))])])])])])])}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-10"
